// extracted by mini-css-extract-plugin
export default {"galleryWrapper":"Gallery_galleryWrapper__J7laT","enlargeButton":"Gallery_enlargeButton__5B+BG"};